import React, { useState } from "react";
import { FiGlobe, FiSmartphone, FiCreditCard, FiMonitor, FiPenTool, FiZap, FiCloud, FiStar, FiArrowUpRight, FiCheckCircle } from "react-icons/fi";
import "./Services.css";
import ApplicationForm from "./ApplicationForm";
import { triggerApplyModal } from "../App";

export default function Services() {
  const [activeCategory, setActiveCategory] = useState("all");
  const [showForm, setShowForm] = useState(false);

  const services = [
    {
      id: "web-dev",
      category: "web",
      icon: <FiGlobe />,
      title: "Custom Web Application Development",
      tag: "WEB ENGINEERING",
      desc: "High-performance, ultra-responsive web portals, e-commerce applications, and secure client dashboards engineered with React, Next.js, Node.js, and Tailwind CSS.",
      highlights: ["Sub-second page loading speed", "SEO & Mobile responsive design", "Secure admin control portals"],
      cta: <>Get Web Proposal <FiArrowUpRight /></>
    },
    {
      id: "app-dev",
      category: "mobile",
      icon: <FiSmartphone />,
      title: "Mobile App Development (iOS & Android)",
      tag: "MOBILE ENGINEERING",
      desc: "Native and cross-platform mobile apps crafted with Flutter and React Native. Complete with offline mode, biometric login, push alerts, and payment gateways.",
      highlights: ["React Native & Flutter expertise", "Biometric & OTP security", "Play Store & App Store deployment"],
      cta: <>Get Mobile Proposal <FiArrowUpRight /></>
    },
    {
      id: "fintech-software",
      category: "fintech",
      icon: <FiCreditCard />,
      title: "Fintech & Payment Software Solutions",
      tag: "FINTECH ENGINEERING",
      desc: "Custom loan origination systems, automated e-KYC workflows, repayment gateways, and NBFC management software designed for bank-grade reliability.",
      highlights: ["Automated CIBIL & e-KYC integration", "256-bit bank-grade encryption", "Real-time ledger & transaction reporting"],
      cta: <>Consult Fintech Lead <FiArrowUpRight /></>
    },
    {
      id: "custom-saas",
      category: "cloud",
      icon: <FiMonitor />,
      title: "Enterprise SaaS & Cloud Architecture",
      tag: "CLOUD & SAAS",
      desc: "Scalable backend microservices, multi-tenant SaaS platforms, REST/GraphQL APIs, and cloud infrastructure engineered on AWS and Google Cloud Platform.",
      highlights: ["Zero-downtime CI/CD pipelines", "Auto-scaling cloud infrastructure", "High-throughput microservices"],
      cta: <>Consult Cloud Engineers <FiArrowUpRight /></>
    },
    {
      id: "uiux-design",
      category: "design",
      icon: <FiPenTool />,
      title: "UI/UX & Product Experience Design",
      tag: "PRODUCT DESIGN",
      desc: "User-centered design systems, clickable Figma prototypes, wireframing, and conversion-optimized interfaces tailored for web and mobile products.",
      highlights: ["Interactive Figma clickable mockups", "Reusable design token system", "Conversion-focused user journeys"],
      cta: <>Start Design Project <FiArrowUpRight /></>
    },
    {
      id: "cloud-api",
      category: "cloud",
      icon: <FiZap />,
      title: "API Development & Payment Integrations",
      tag: "API & INTEGRATIONS",
      desc: "Custom REST/GraphQL API creation, webhook receiver pipelines, and seamless integration with payment gateways (Razorpay, Cashfree, Stripe) and banking APIs.",
      highlights: ["Low-latency API response (<50ms)", "Swagger / Postman API docs", "Secure webhook callback handling"],
      cta: <>Discuss API Setup <FiArrowUpRight /></>
    }
  ];

  const filteredServices = activeCategory === "all"
    ? services
    : services.filter(s => s.category === activeCategory);

  return (
    <div className="services-page" style={{ paddingTop: '6rem', minHeight: '85vh' }}>
      <div className="fintech-container">
        {/* Header */}
        <div className="services-header" style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
          <span className="section-eyebrow">KUBERSETU INFOTECH SERVICES</span>
          <h1 className="gradient-text">Software & Technology Engineering Services</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: '1.15rem', maxWidth: '800px', margin: '0.75rem auto 0', lineHeight: '1.7' }}>
            Kubersetu Infotech Private Limited provides custom software engineering, high-speed web application development, iOS & Android mobile apps, and enterprise cloud solutions.
          </p>

          {/* Category Filter Pills */}
          <div className="services-filter-tabs">
            <button
              className={`filter-tab ${activeCategory === "all" ? "active" : ""}`}
              onClick={() => setActiveCategory("all")}
            >
              All Tech Services <FiStar />
            </button>
            <button
              className={`filter-tab ${activeCategory === "web" ? "active" : ""}`}
              onClick={() => setActiveCategory("web")}
            >
              <FiGlobe /> Web Apps
            </button>
            <button
              className={`filter-tab ${activeCategory === "mobile" ? "active" : ""}`}
              onClick={() => setActiveCategory("mobile")}
            >
              <FiSmartphone /> Mobile Apps
            </button>
            <button
              className={`filter-tab ${activeCategory === "fintech" ? "active" : ""}`}
              onClick={() => setActiveCategory("fintech")}
            >
              <FiCreditCard /> Fintech Software
            </button>
            <button
              className={`filter-tab ${activeCategory === "cloud" ? "active" : ""}`}
              onClick={() => setActiveCategory("cloud")}
            >
              <FiCloud /> Cloud & APIs
            </button>
            <button
              className={`filter-tab ${activeCategory === "design" ? "active" : ""}`}
              onClick={() => setActiveCategory("design")}
            >
              <FiPenTool /> UI/UX Design
            </button>
          </div>
        </div>

        {/* Services Grid */}
        <div className="services-bento-grid">
          {filteredServices.map((service) => (
            <div key={service.id} className="bento-box service-bento-card">
              <div className="service-card-top">
                <span className="service-icon">{service.icon}</span>
                <span className="service-tag">{service.tag}</span>
              </div>
              <h3 className="service-card-title">{service.title}</h3>
              <p className="service-card-desc">{service.desc}</p>
              
              <ul className="service-highlights">
                {service.highlights.map((h, i) => (
                  <li key={i}>
                    <span className="check-icon"><FiCheckCircle /></span>
                    <span>{h}</span>
                  </li>
                ))}
              </ul>

              <button
                className="btn btn-primary w-full service-cta-btn"
                onClick={() => triggerApplyModal(service.title)}
              >
                {service.cta}
              </button>
            </div>
          ))}
        </div>
      </div>

      {showForm && (
        <ApplicationForm onClose={() => setShowForm(false)} />
      )}
    </div>
  );
}
